import * as React from 'react';
import { Input, InputOnChangeData, InputProps } from 'semantic-ui-react';

interface Props extends InputProps {
    loading?: never;
    value?: never;
    onChange?: never;
    milliseconds?: number;
    enableLoader?: boolean | ((text: string) => boolean);
    onTimeout(event: React.SyntheticEvent<HTMLInputElement>, data: InputOnChangeData): void;
}

interface State {
    texto: string;
    cargando: boolean;
}

class InputTimeout extends React.Component<Props, State> {
    public state: State = {
        texto: '',
        cargando: false,
    };

    private timeoutId: number | undefined;

    public render() {
        const { texto, cargando } = this.state;
        const {
            loading: _l,
            value: _v,
            onChange: _o,
            milliseconds = 250,
            onTimeout,
            enableLoader,
            ...otrosProps
        } = this.props;

        const loaderEnabled =
            typeof enableLoader === 'function' ? enableLoader(texto) : enableLoader || false;

        return (
            <Input
                loading={loaderEnabled && cargando}
                value={texto}
                onChange={(e, p) => {
                    this.setState({ texto: p.value, cargando: true });
                    // Debounce
                    clearTimeout(this.timeoutId);
                    this.timeoutId = window.setTimeout(() => {
                        this.setState({ cargando: false });
                        onTimeout(e, p);
                    }, milliseconds);
                }}
                {...otrosProps}
            />
        );
    }
}

export default InputTimeout;



// WEBPACK FOOTER //
// ./src/componentes/semantic-ui-extended/InputTimeout/index.tsx